module.exports = __webpack_public_path__ + "img/de_bg_8.f6ca23a1.jpeg";